import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ExpandableChart = ({ children, title, images }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-white rounded-lg shadow-md border border-gray-100">
      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          {images && images.length > 0 && (
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="flex items-center text-blue-600 hover:text-blue-700"
            >
              {isExpanded ? (
                <>
                  <span className="mr-1">Show Less</span>
                  <ChevronUp size={20} />
                </>
              ) : (
                <>
                  <span className="mr-1">Show More</span>
                  <ChevronDown size={20} />
                </>
              )}
            </button>
          )}
        </div>

        {children}

        {isExpanded && images && images.length > 0 && (
          <div className="mt-6 border-t border-gray-200 pt-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {images.map((image, index) => (
                <div key={index} className="flex flex-col items-center">
                  <img
                    src={`/${image}`}
                    alt={`Analysis ${index + 1}`}
                    className="rounded-lg shadow-md max-w-full h-auto"
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpandableChart;